"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1254,5141,4099],{

/***/ 862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ BaseFetcher; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26297);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87394);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50853);
/* harmony import */ var _kernel_DomainError__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11455);
/* harmony import */ var _kernel_ErrorsCode__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65694);









var BaseFetcher = /*#__PURE__*/ function() {
    "use strict";
    function BaseFetcher(config, token) {
        var _this = this;
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, BaseFetcher);
        this.config = config;
        this.token = token;
        this.mapper = function(url) {
            return url;
        };
        var _this1 = this;
        this.get = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(url) {
                var options, schemas, innerOptions;
                var _arguments = arguments;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    schemas = options.schemas, innerOptions = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(options, [
                        "schemas"
                    ]);
                    return [
                        2,
                        _this1.request(url, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, innerOptions), {
                            method: "get"
                        }), schemas)
                    ];
                });
            });
            return function(url) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this2 = this;
        this.del = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(url) {
                var options, schemas, innerOptions;
                var _arguments = arguments;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    schemas = options.schemas, innerOptions = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(options, [
                        "schemas"
                    ]);
                    return [
                        2,
                        _this2.request(url, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, innerOptions), {
                            method: "delete"
                        }), schemas)
                    ];
                });
            });
            return function(url) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this3 = this;
        this.post = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(url) {
                var options, schemas, innerOptions;
                var _arguments = arguments;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    schemas = options.schemas, innerOptions = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(options, [
                        "schemas"
                    ]);
                    return [
                        2,
                        _this3.request(url, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, innerOptions), {
                            method: "post"
                        }), schemas)
                    ];
                });
            });
            return function(url) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this4 = this;
        this.put = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(url) {
                var options, schemas, innerOptions;
                var _arguments = arguments;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    schemas = options.schemas, innerOptions = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(options, [
                        "schemas"
                    ]);
                    return [
                        2,
                        _this4.request(url, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, innerOptions), {
                            method: "put"
                        }), schemas)
                    ];
                });
            });
            return function(url) {
                return _ref.apply(this, arguments);
            };
        }();
        this.withAuth = function() {
            if (!_this.token) throw _kernel_DomainError__WEBPACK_IMPORTED_MODULE_0__/* .DomainError.withCodes */ .Z.withCodes(_kernel_ErrorsCode__WEBPACK_IMPORTED_MODULE_1__/* .ErrorsCode.MISSING_AUTH_TOKEN */ .v.MISSING_AUTH_TOKEN);
            // The intention of this method is to force it to be declarative
            // when we mark a request as authenticated, that's why we use
            // the property rename, forcing us to execute the method when
            // we want the request to be authenticated:
            _this.authToken = _this.token;
            return _this;
        };
        this.withAuthMapper = function(mapper) {
            try {
                if (_this.withAuth()) {
                    _this.mapper = mapper;
                }
            } catch (e) {
                _this.mapper = function(url) {
                    return url;
                };
            }
            return _this;
        };
    }
    var _proto = BaseFetcher.prototype;
    _proto.request = function request(url, options, schemas) {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
            var ref, ref1, queryString, queryParams, internalFetcher, resp, respCloned, ref2, textContent, json, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        if (url.includes("?") && !(schemas === null || schemas === void 0 ? void 0 : schemas.query)) throw _kernel_DomainError__WEBPACK_IMPORTED_MODULE_0__/* .DomainError.withCodes */ .Z.withCodes(_kernel_ErrorsCode__WEBPACK_IMPORTED_MODULE_1__/* .ErrorsCode.MISSING_QUERY_SCHEMA */ .v.MISSING_QUERY_SCHEMA) // prettier-ignore
                        ;
                        if ((options === null || options === void 0 ? void 0 : options.body) && !(schemas === null || schemas === void 0 ? void 0 : schemas.body)) throw _kernel_DomainError__WEBPACK_IMPORTED_MODULE_0__/* .DomainError.withCodes */ .Z.withCodes(_kernel_ErrorsCode__WEBPACK_IMPORTED_MODULE_1__/* .ErrorsCode.MISSING_BODY_SCHEMA */ .v.MISSING_BODY_SCHEMA) // prettier-ignore
                        ;
                        if (url.includes("?")) {
                            ;
                            queryString = url.split("?")[1];
                            queryParams = Object.fromEntries(new URLSearchParams(queryString).entries());
                            schemas === null || schemas === void 0 ? void 0 : (ref1 = schemas.query) === null || ref1 === void 0 ? void 0 : ref1.parse(queryParams);
                        }
                        if (options === null || options === void 0 ? void 0 : options.body) schemas === null || schemas === void 0 ? void 0 : (ref = schemas.body) === null || ref === void 0 ? void 0 : ref.parse(JSON.parse(options.body));
                        internalFetcher = _this.fetch();
                        return [
                            4,
                            internalFetcher(_this.mapper(url), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, options, _this.authToken && {
                                credentials: "include"
                            }), {
                                headers: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, (options === null || options === void 0 ? void 0 : options.headers) || {}, {
                                    "Content-Type": "application/json; charset=utf-8"
                                }, _this.authToken && {
                                    cookie: "sfl_user=".concat(encodeURIComponent(_this.authToken))
                                })
                            }))
                        ];
                    case 1:
                        resp = _state.sent();
                        respCloned = resp.clone();
                        if (!resp.ok) throw respCloned;
                        return [
                            4,
                            Promise.all([
                                resp.text(),
                                respCloned.text()
                            ])
                        ];
                    case 2:
                        ref2 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"].apply */ .Z.apply(void 0, [
                            _state.sent(),
                            1
                        ]), textContent = ref2[0];
                        json = Boolean(textContent.length) && JSON.parse(textContent);
                        if (json && Object.keys(json).length !== 0 && !(schemas === null || schemas === void 0 ? void 0 : schemas.response)) throw _kernel_DomainError__WEBPACK_IMPORTED_MODULE_0__/* .DomainError.withCodes */ .Z.withCodes(_kernel_ErrorsCode__WEBPACK_IMPORTED_MODULE_1__/* .ErrorsCode.MISSING_RESPONSE_SCHEMA */ .v.MISSING_RESPONSE_SCHEMA) // prettier-ignore
                        ;
                        if (schemas === null || schemas === void 0 ? void 0 : schemas.response) schemas === null || schemas === void 0 ? void 0 : schemas.response.parse(json);
                        return [
                            2,
                            [
                                undefined,
                                json
                            ]
                        ];
                    case 3:
                        error = _state.sent();
                        return [
                            2,
                            [
                                error,
                                undefined
                            ]
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    return BaseFetcher;
}();
BaseFetcher.AUTH_COOKIE_NAME = "sfl_user";


/***/ }),

/***/ 97081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ FactoryFetcher; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87394);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50853);
/* harmony import */ var _cookie_FactoryCookie__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65509);
/* harmony import */ var _kernel_Environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24880);
/* harmony import */ var _BaseFetcher__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(862);







var FactoryFetcher = /*#__PURE__*/ function() {
    "use strict";
    function FactoryFetcher(config) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, FactoryFetcher);
        this.config = config;
    }
    var _proto = FactoryFetcher.prototype;
    _proto.fetcher = function fetcher() {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
            var isNode, token, _tmp;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isNode = _kernel_Environment__WEBPACK_IMPORTED_MODULE_4__/* .Environment.create */ .q.create().isNode();
                        return [
                            4,
                            _this.getAuthToken()
                        ];
                    case 1:
                        token = _state.sent();
                        if (!isNode) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            __webpack_require__.e(/* import() */ 8257).then(__webpack_require__.t.bind(__webpack_require__, 58257, 23))
                        ];
                    case 2:
                        _tmp = _state.sent().NodeFetcher.create({
                            config: _this.config,
                            token: token
                        });
                        return [
                            3,
                            5
                        ];
                    case 3:
                        return [
                            4,
                            __webpack_require__.e(/* import() */ 6809).then(__webpack_require__.bind(__webpack_require__, 66809))
                        ];
                    case 4:
                        _tmp = _state.sent().WindowFetcher.create({
                            config: _this.config,
                            token: token
                        });
                        _state.label = 5;
                    case 5:
                        return [
                            2,
                            _tmp
                        ];
                }
            });
        })();
    };
    _proto.getAuthToken = function getAuthToken() {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
            var cookie, ref, token;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _cookie_FactoryCookie__WEBPACK_IMPORTED_MODULE_5__/* .FactoryCookie.create */ .f.create({
                                config: _this.config
                            }).cookie()
                        ];
                    case 1:
                        cookie = _state.sent();
                        ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(cookie.get({
                            key: _BaseFetcher__WEBPACK_IMPORTED_MODULE_0__/* .BaseFetcher.AUTH_COOKIE_NAME */ .p.AUTH_COOKIE_NAME
                        }), 2), token = ref[1];
                        return [
                            2,
                            token
                        ];
                }
            });
        })();
    };
    FactoryFetcher.create = function create(param) {
        var config = param.config;
        return new FactoryFetcher(config);
    };
    return FactoryFetcher;
}();


/***/ }),

/***/ 61659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ TitleValidation; }
/* harmony export */ });
/* unused harmony export Title */
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53538);






var TitleValidation = zod__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry({
    value: zod__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_({
        required_error: "[Title] value is required"
    })
});
var Title = /*#__PURE__*/ (/* unused pure expression or super */ null && (function(Model) {
    "use strict";
    _inherits(Title, Model);
    var _super = _create_super(Title);
    function Title(_value, _empty) {
        _class_call_check(this, Title);
        var _this;
        _this = _super.call(this);
        _this._value = _value;
        _this._empty = _empty;
        return _this;
    }
    var _proto = Title.prototype;
    _proto.isEmpty = function isEmpty() {
        return this._empty;
    };
    _proto.toJSON = function toJSON() {
        return {
            value: this.value
        };
    };
    Title.create = function create(param) {
        var value = param.value;
        TitleValidation.parse({
            value: value
        });
        return new Title(value, false);
    };
    Title.empty = function empty() {
        return new Title("", true);
    };
    _create_class(Title, [
        {
            key: "value",
            get: function get() {
                return this._value;
            } // prettier-ignore
        }
    ]);
    return Title;
}(Model)));


/***/ }),

/***/ 44304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* binding */ HTTPMarketingRepository; }
});

// NAMESPACE OBJECT: ../../node_modules/zod/v3/external.js
var external_namespaceObject = {};
__webpack_require__.r(external_namespaceObject);
__webpack_require__.d(external_namespaceObject, {
  "BRAND": function() { return types/* BRAND */.cg; },
  "DIRTY": function() { return parseUtil/* DIRTY */.RC; },
  "EMPTY_PATH": function() { return parseUtil/* EMPTY_PATH */.h2; },
  "INVALID": function() { return parseUtil/* INVALID */.UI; },
  "NEVER": function() { return types/* NEVER */.C4; },
  "OK": function() { return parseUtil.OK; },
  "ParseStatus": function() { return parseUtil/* ParseStatus */.Q9; },
  "Schema": function() { return types/* Schema */.V_; },
  "ZodAny": function() { return types/* ZodAny */.O8; },
  "ZodArray": function() { return types/* ZodArray */.p5; },
  "ZodBigInt": function() { return types/* ZodBigInt */.EG; },
  "ZodBoolean": function() { return types/* ZodBoolean */.pZ; },
  "ZodBranded": function() { return types/* ZodBranded */.Gd; },
  "ZodCatch": function() { return types/* ZodCatch */.ON; },
  "ZodDate": function() { return types/* ZodDate */.$s; },
  "ZodDefault": function() { return types/* ZodDefault */.uE; },
  "ZodDiscriminatedUnion": function() { return types/* ZodDiscriminatedUnion */.Iy; },
  "ZodEffects": function() { return types/* ZodEffects */.Xc; },
  "ZodEnum": function() { return types/* ZodEnum */.K7; },
  "ZodError": function() { return ZodError/* ZodError */.jm; },
  "ZodFirstPartyTypeKind": function() { return types/* ZodFirstPartyTypeKind */.pA; },
  "ZodFunction": function() { return types/* ZodFunction */.b_; },
  "ZodIntersection": function() { return types/* ZodIntersection */.f9; },
  "ZodIssueCode": function() { return ZodError/* ZodIssueCode */.NL; },
  "ZodLazy": function() { return types/* ZodLazy */.dT; },
  "ZodLiteral": function() { return types/* ZodLiteral */.SG; },
  "ZodMap": function() { return types/* ZodMap */.Ym; },
  "ZodNaN": function() { return types/* ZodNaN */.Hu; },
  "ZodNativeEnum": function() { return types/* ZodNativeEnum */.Zl; },
  "ZodNever": function() { return types/* ZodNever */.$n; },
  "ZodNull": function() { return types/* ZodNull */.pV; },
  "ZodNullable": function() { return types/* ZodNullable */.ng; },
  "ZodNumber": function() { return types/* ZodNumber */.IV; },
  "ZodObject": function() { return types/* ZodObject */.CQ; },
  "ZodOptional": function() { return types/* ZodOptional */.ak; },
  "ZodParsedType": function() { return util/* ZodParsedType */.$k; },
  "ZodPipeline": function() { return types/* ZodPipeline */.om; },
  "ZodPromise": function() { return types/* ZodPromise */.Wx; },
  "ZodReadonly": function() { return types/* ZodReadonly */.ur; },
  "ZodRecord": function() { return types/* ZodRecord */.KX; },
  "ZodSchema": function() { return types/* ZodSchema */.I6; },
  "ZodSet": function() { return types/* ZodSet */.qA; },
  "ZodString": function() { return types/* ZodString */.$T; },
  "ZodSymbol": function() { return types/* ZodSymbol */.tX; },
  "ZodTransformer": function() { return types/* ZodTransformer */.z2; },
  "ZodTuple": function() { return types/* ZodTuple */._P; },
  "ZodType": function() { return types/* ZodType */.DI; },
  "ZodUndefined": function() { return types/* ZodUndefined */.DY; },
  "ZodUnion": function() { return types/* ZodUnion */.jp; },
  "ZodUnknown": function() { return types/* ZodUnknown */.Dy; },
  "ZodVoid": function() { return types/* ZodVoid */.XE; },
  "addIssueToContext": function() { return parseUtil/* addIssueToContext */.KD; },
  "any": function() { return types/* any */.Yj; },
  "array": function() { return types/* array */.IX; },
  "bigint": function() { return types/* bigint */.Kv; },
  "boolean": function() { return types/* boolean */.O7; },
  "coerce": function() { return types/* coerce */.oQ; },
  "custom": function() { return types/* custom */.PG; },
  "date": function() { return types/* date */.hT; },
  "datetimeRegex": function() { return types/* datetimeRegex */.wU; },
  "defaultErrorMap": function() { return errors/* defaultErrorMap */.jY; },
  "discriminatedUnion": function() { return types/* discriminatedUnion */.VK; },
  "effect": function() { return types/* effect */.cE; },
  "enum": function() { return types/* enum */.Km; },
  "function": function() { return types/* function */.ZI; },
  "getErrorMap": function() { return errors/* getErrorMap */.Pr; },
  "getParsedType": function() { return util/* getParsedType */.FQ; },
  "instanceof": function() { return types/* instanceof */.Pp; },
  "intersection": function() { return types/* intersection */.jV; },
  "isAborted": function() { return parseUtil/* isAborted */.Hc; },
  "isAsync": function() { return parseUtil/* isAsync */.S9; },
  "isDirty": function() { return parseUtil/* isDirty */.eT; },
  "isValid": function() { return parseUtil/* isValid */.JY; },
  "late": function() { return types/* late */.wt; },
  "lazy": function() { return types/* lazy */.Vo; },
  "literal": function() { return types/* literal */.i0; },
  "makeIssue": function() { return parseUtil/* makeIssue */.Xm; },
  "map": function() { return types/* map */.UI; },
  "nan": function() { return types/* nan */.qn; },
  "nativeEnum": function() { return types/* nativeEnum */.jb; },
  "never": function() { return types/* never */.Fi; },
  "null": function() { return types/* null */.lB; },
  "nullable": function() { return types/* nullable */.AG; },
  "number": function() { return types/* number */.Rx; },
  "object": function() { return types/* object */.Ry; },
  "objectUtil": function() { return util/* objectUtil */.Mg; },
  "oboolean": function() { return types/* oboolean */.Ts; },
  "onumber": function() { return types/* onumber */.vs; },
  "optional": function() { return types/* optional */.jt; },
  "ostring": function() { return types/* ostring */.Dk; },
  "pipeline": function() { return types/* pipeline */.EU; },
  "preprocess": function() { return types/* preprocess */.dj; },
  "promise": function() { return types/* promise */.MC; },
  "quotelessJson": function() { return ZodError/* quotelessJson */.Zh; },
  "record": function() { return types/* record */.IM; },
  "set": function() { return types/* set */.t8; },
  "setErrorMap": function() { return errors/* setErrorMap */.DJ; },
  "strictObject": function() { return types/* strictObject */.cf; },
  "string": function() { return types/* string */.Z_; },
  "symbol": function() { return types/* symbol */.NA; },
  "transformer": function() { return types/* transformer */.l4; },
  "tuple": function() { return types/* tuple */.bc; },
  "undefined": function() { return types/* undefined */.S1; },
  "union": function() { return types/* union */.G0; },
  "unknown": function() { return types/* unknown */._4; },
  "util": function() { return util/* util */.D5; },
  "void": function() { return types/* void */.Hc; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50853);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27805);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(64297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_super.mjs + 2 modules
var _create_super = __webpack_require__(39309);
// EXTERNAL MODULE: ../../node_modules/zod/v3/types.js + 1 modules
var types = __webpack_require__(53538);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/architecture.ts
var architecture = __webpack_require__(70163);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/Slug.ts
var Slug = __webpack_require__(30714);
// EXTERNAL MODULE: ../../packages/stayforlong/src/marketing/domain/PromotionTag.ts
var PromotionTag = __webpack_require__(95344);
// EXTERNAL MODULE: ../../packages/stayforlong/src/shared/domain/Market.ts
var Market = __webpack_require__(14828);
;// CONCATENATED MODULE: ../../packages/stayforlong/src/shared/domain/ListOfMarket.ts







var ListOfMarketValidation = types/* object */.Ry({
    list: types/* instanceof */.Pp(Market/* Market */.IY, {
        message: "[ListOfMarket] list is required"
    }).array()
});
var ListOfMarket = /*#__PURE__*/ function(Model) {
    "use strict";
    (0,_inherits/* default */.Z)(ListOfMarket, Model);
    var _super = (0,_create_super/* default */.Z)(ListOfMarket);
    function ListOfMarket(_list) {
        (0,_class_call_check/* default */.Z)(this, ListOfMarket);
        var _this;
        _this = _super.call(this);
        _this._list = _list;
        return _this;
    }
    var _proto = ListOfMarket.prototype;
    _proto.has = function has(param) {
        var market = param.market;
        if (!market.isFilled()) return false;
        return this._list.some(function(internalMarket) {
            return internalMarket.is(market.value);
        });
    };
    _proto.isEmpty = function isEmpty() {
        return this._list.length === 0;
    };
    _proto.toJSON = function toJSON() {
        return {
            list: this._list.map(function(item) {
                return item.toJSON();
            })
        };
    };
    ListOfMarket.create = function create(param) {
        var list = param.list;
        ListOfMarketValidation.parse({
            list: list
        });
        return new ListOfMarket(list);
    };
    ListOfMarket.empty = function empty() {
        return new ListOfMarket([]);
    };
    ListOfMarket.fromArray = function fromArray(param) {
        var markets = param.markets;
        return ListOfMarket.create({
            list: markets.map(function(market) {
                return Market/* Market.create */.IY.create({
                    value: market
                });
            })
        });
    };
    ListOfMarket.fromJSON = function fromJSON(param) {
        var json = param.json;
        return ListOfMarket.create({
            list: json.list.map(function(marketJson) {
                return Market/* Market.fromJSON */.IY.fromJSON(marketJson);
            })
        });
    };
    (0,_create_class/* default */.Z)(ListOfMarket, [
        {
            key: "list",
            get: function get() {
                return this._list;
            } // prettier-ignore
        }
    ]);
    return ListOfMarket;
}(architecture/* Model */.H);

// EXTERNAL MODULE: ../../packages/stayforlong/src/shared/domain/Language.ts
var Language = __webpack_require__(43491);
;// CONCATENATED MODULE: ../../packages/stayforlong/src/shared/domain/ListOfLanguage.ts







var ListOfLanguageValidation = types/* object */.Ry({
    list: types/* instanceof */.Pp(Language/* Language */.S, {
        message: "[ListOfLanguage] list is required"
    }).array()
});
var ListOfLanguage = /*#__PURE__*/ function(Model) {
    "use strict";
    (0,_inherits/* default */.Z)(ListOfLanguage, Model);
    var _super = (0,_create_super/* default */.Z)(ListOfLanguage);
    function ListOfLanguage(_list) {
        (0,_class_call_check/* default */.Z)(this, ListOfLanguage);
        var _this;
        _this = _super.call(this);
        _this._list = _list;
        return _this;
    }
    var _proto = ListOfLanguage.prototype;
    _proto.toJSON = function toJSON() {
        return {
            list: this._list.map(function(item) {
                return item.toJSON();
            })
        };
    };
    ListOfLanguage.create = function create(param) {
        var list = param.list;
        ListOfLanguageValidation.parse({
            list: list
        });
        return new ListOfLanguage(list);
    };
    ListOfLanguage.empty = function empty() {
        return new ListOfLanguage([]);
    };
    ListOfLanguage.fromArray = function fromArray(param) {
        var languages = param.languages;
        return ListOfLanguage.create({
            list: languages.map(function(lang) {
                return Language/* Language.create */.S.create({
                    value: lang
                });
            })
        });
    };
    ListOfLanguage.fromJSON = function fromJSON(param) {
        var json = param.json;
        return ListOfLanguage.create({
            list: json.list.map(function(languageJSON) {
                return Language/* Language.fromJSON */.S.fromJSON(languageJSON);
            })
        });
    };
    (0,_create_class/* default */.Z)(ListOfLanguage, [
        {
            key: "list",
            get: function get() {
                return this._list;
            } // prettier-ignore
        }
    ]);
    return ListOfLanguage;
}(architecture/* Model */.H);

;// CONCATENATED MODULE: ../../packages/stayforlong/src/marketing/domain/Promotion.ts













var PromotionValidation = types/* object */.Ry({
    id: types/* instanceof */.Pp(Slug/* Slug */.e, {
        message: "[Promotion} id value is required"
    }),
    tag: types/* instanceof */.Pp(PromotionTag/* PromotionTag */.s, {
        message: "[Promotion] tag is required"
    }),
    market: types/* instanceof */.Pp(Market/* Market */.IY, {
        message: "[Promotion] market is required"
    }),
    language: types/* instanceof */.Pp(Language/* Language */.S, {
        message: "[Promotion] language is required"
    }),
    markets: types/* instanceof */.Pp(ListOfMarket).optional(),
    languages: types/* instanceof */.Pp(ListOfLanguage).optional()
});
var Promotion = /*#__PURE__*/ function(Model) {
    "use strict";
    (0,_inherits/* default */.Z)(Promotion, Model);
    var _super = (0,_create_super/* default */.Z)(Promotion);
    function Promotion(_id, _tag, _market, _language, _markets, _languages) {
        (0,_class_call_check/* default */.Z)(this, Promotion);
        var _this;
        _this = _super.call(this);
        _this._id = _id;
        _this._tag = _tag;
        _this._market = _market;
        _this._language = _language;
        _this._markets = _markets;
        _this._languages = _languages;
        return _this;
    }
    var _proto = Promotion.prototype;
    _proto.isEmpty = function isEmpty() {
        return this._id.isEmpty();
    };
    _proto.toJSON = function toJSON() {
        return (0,_object_spread/* default */.Z)({
            id: this._id.value,
            tag: this._tag.toJSON(),
            market: this._market.toJSON(),
            language: this._language.toJSON()
        }, this._markets && {
            markets: this._markets.toJSON()
        }, this._languages && {
            languages: this._languages.toJSON()
        });
    };
    Promotion.create = function create(param) {
        var id = param.id, tag = param.tag, market = param.market, language = param.language, markets = param.markets, languages = param.languages;
        PromotionValidation.parse({
            id: id,
            tag: tag,
            market: market,
            language: language,
            markets: markets,
            languages: languages
        });
        return new Promotion(id, tag, market, language, markets, languages);
    };
    Promotion.empty = function empty() {
        return new Promotion(Slug/* Slug.empty */.e.empty(), PromotionTag/* PromotionTag.empty */.s.empty(), Market/* Market.empty */.IY.empty(), Language/* Language.empty */.S.empty());
    };
    Promotion.fromJSONOrEmpty = function fromJSONOrEmpty(param) {
        var json = param.json;
        if (!json) return Promotion.empty();
        return Promotion.create((0,_object_spread/* default */.Z)({
            id: Slug/* Slug.create */.e.create({
                value: json.id
            }),
            tag: PromotionTag/* PromotionTag.fromJSON */.s.fromJSON({
                json: json.tag
            }),
            market: Market/* Market.fromJSON */.IY.fromJSON(json.market),
            language: Language/* Language.fromJSON */.S.fromJSON(json.language)
        }, json.markets && {
            markets: ListOfMarket.fromJSON({
                json: json.markets
            })
        }, json.languages && {
            languages: ListOfLanguage.fromJSON({
                json: json.languages
            })
        }));
    };
    Promotion.fromAPI = function fromAPI(param) {
        var json = param.json, market = param.market, language = param.language;
        if (!json) return Promotion.empty();
        return Promotion.create({
            id: Slug/* Slug.create */.e.create({
                value: json.slug
            }),
            tag: PromotionTag/* PromotionTag.fromJSON */.s.fromJSON({
                json: json.global.tags
            }),
            market: market,
            language: language
        });
    };
    (0,_create_class/* default */.Z)(Promotion, [
        {
            key: "id",
            get: function get() {
                return this._id.value;
            }
        },
        {
            key: "tag",
            get: function get() {
                return this._tag;
            }
        },
        {
            key: "markets",
            get: function get() {
                return this._markets;
            }
        },
        {
            key: "languages",
            get: function get() {
                return this._languages;
            }
        }
    ]);
    return Promotion;
}(architecture/* Model */.H);

;// CONCATENATED MODULE: ../../packages/stayforlong/src/marketing/domain/ListOfPromotion.ts







var ListOfPromotionValidation = types/* object */.Ry({
    list: types/* instanceof */.Pp(Promotion, {
        message: "[ListOfPromotion] list is required"
    }).array()
});
var ListOfPromotion = /*#__PURE__*/ function(Model) {
    "use strict";
    (0,_inherits/* default */.Z)(ListOfPromotion, Model);
    var _super = (0,_create_super/* default */.Z)(ListOfPromotion);
    function ListOfPromotion(_list) {
        (0,_class_call_check/* default */.Z)(this, ListOfPromotion);
        var _this;
        _this = _super.call(this);
        _this._list = _list;
        return _this;
    }
    var _proto = ListOfPromotion.prototype;
    _proto.findById = function findById(param) {
        var id = param.id;
        return this._list.find(function(promotion) {
            return promotion.id === id.value;
        });
    };
    _proto.getFirstOrEmpty = function getFirstOrEmpty() {
        var ref;
        return (ref = this._list[0]) !== null && ref !== void 0 ? ref : Promotion.empty();
    };
    _proto.toJSON = function toJSON() {
        return {
            list: this._list.map(function(item) {
                return item.toJSON();
            })
        };
    };
    ListOfPromotion.create = function create(param) {
        var list = param.list;
        ListOfPromotionValidation.parse({
            list: list
        });
        return new ListOfPromotion(list);
    };
    ListOfPromotion.empty = function empty() {
        return new ListOfPromotion([]);
    };
    ListOfPromotion.fromAPI = function fromAPI(param) {
        var json = param.json, market = param.market, language = param.language;
        if (!json) {
            return ListOfPromotion.empty();
        }
        return ListOfPromotion.create({
            list: json.map(function(promo) {
                return Promotion.fromAPI({
                    json: promo,
                    market: market,
                    language: language
                });
            })
        });
    };
    (0,_create_class/* default */.Z)(ListOfPromotion, [
        {
            key: "list",
            get: function get() {
                return this._list;
            } // prettier-ignore
        }
    ]);
    return ListOfPromotion;
}(architecture/* Model */.H);

// EXTERNAL MODULE: ../../packages/stayforlong/src/_fetcher/FactoryFetcher.ts
var FactoryFetcher = __webpack_require__(97081);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/DomainError.ts
var DomainError = __webpack_require__(11455);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/ErrorsCode.ts
var ErrorsCode = __webpack_require__(65694);
// EXTERNAL MODULE: ../../packages/stayforlong/src/marketing/domain/ListOfBanner.ts + 5 modules
var ListOfBanner = __webpack_require__(72009);
// EXTERNAL MODULE: ../../packages/stayforlong/src/marketing/domain/ListOfTopDestination.ts + 1 modules
var ListOfTopDestination = __webpack_require__(46539);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/Name.ts
var Name = __webpack_require__(82634);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/FullName.ts
var FullName = __webpack_require__(80712);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/Count.ts
var Count = __webpack_require__(21328);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/Description.ts
var Description = __webpack_require__(59579);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/Path.ts
var Path = __webpack_require__(17043);
;// CONCATENATED MODULE: ../../packages/stayforlong/src/marketing/infrastructure/HTTPMarketingRepository/schemas/banners/:id/destinations/index.ts









var GETTopDestinationsByBannerIdQuery = types/* object */.Ry({
    lang: Language/* LanguageValidation.shape.value */._.shape.value,
    market: Market/* MarketValidation.shape.value */.iT.shape.value
});
var ImageValidation = types/* union */.G0([
    types/* object */.Ry({
        portrait: Path/* PathValidation.shape.value */.L.shape.value,
        wide: Path/* PathValidation.shape.value.optional */.L.shape.value.optional()
    }),
    types/* object */.Ry({
        portrait: Path/* PathValidation.shape.value.optional */.L.shape.value.optional(),
        wide: Path/* PathValidation.shape.value */.L.shape.value
    }),
    types/* object */.Ry({
        portrait: Path/* PathValidation.shape.value */.L.shape.value,
        wide: Path/* PathValidation.shape.value */.L.shape.value
    }), 
]);
var GETTopDestinationsByBannerIdResponse = types/* object */.Ry({
    destinations: types/* object */.Ry({
        name: Name/* NameValidation.shape.value */.C.shape.value,
        full_name: FullName/* FullNameValidation.shape.value */._.shape.value,
        slug: Slug/* SlugValidation.shape.value */.g.shape.value,
        properties_count: Count/* CountValidation.shape.value */.L.shape.value,
        description: Description/* DescriptionValidation.shape.value */.p.shape.value,
        images: ImageValidation
    }).array()
});

// EXTERNAL MODULE: ../../packages/stayforlong/src/shared/domain/Device.ts
var Device = __webpack_require__(72300);
// EXTERNAL MODULE: ../../packages/stayforlong/src/marketing/domain/BannerType.ts
var BannerType = __webpack_require__(58582);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/I18nText.ts
var I18nText = __webpack_require__(3376);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/Url.ts
var Url = __webpack_require__(32675);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/Color.ts
var Color = __webpack_require__(59928);
// EXTERNAL MODULE: ../../packages/stayforlong/src/marketing/domain/BannerSubtype.ts
var BannerSubtype = __webpack_require__(1038);
;// CONCATENATED MODULE: ../../packages/stayforlong/src/marketing/infrastructure/HTTPMarketingRepository/schemas/banners/banners-json/index.ts







// import { ALLOWED_BANNER_SUBTYPES_BY_TYPE } from '../../../../../../marketing/domain/Banner'
var GETBannerInformationResponse = types/* object */.Ry({
    banners: types/* array */.IX(types/* object */.Ry({
        type: BannerType/* BannerTypeValidation.shape.value */.qg.shape.value,
        subtype: BannerSubtype/* BannerSubtypeValidation.shape.value.optional */.ut.shape.value.optional(),
        viewport: types/* enum */.Km(Device/* ALLOWED_DEVICES */.Mz).optional(),
        content: types/* record */.IM(types/* literal */.i0("all"), types/* object */.Ry({
            title: types/* array */.IX(I18nText/* I18nTextValidation.shape.value */.B.shape.value),
            description: I18nText/* I18nTextValidation.shape.value.optional */.B.shape.value.optional(),
            url: Url/* UrlValidation.shape.value.optional */.w.shape.value.optional(),
            ctaText: I18nText/* I18nTextValidation.shape.value.optional */.B.shape.value.optional(),
            bgColor: Color/* ColorValidation.shape.value.optional */.y.shape.value.optional(),
            titleColor: Color/* ColorValidation.shape.value.optional */.y.shape.value.optional(),
            descriptionColor: Color/* ColorValidation.shape.value.optional */.y.shape.value.optional(),
            image: types/* object */.Ry({
                srcSet: Url/* UrlValidation.shape.value.array */.w.shape.value.array(),
                alt: I18nText/* I18nTextValidation.shape.value */.B.shape.value
            }).optional()
        }))
    }))
});
var GETBannerInformationResponseLenient = types/* object */.Ry({
    banners: types/* array */.IX(types/* any */.Yj())
});

;// CONCATENATED MODULE: ../../packages/stayforlong/src/marketing/infrastructure/HTTPMarketingRepository/schemas/banners/index.ts







var BillboardImageSchema = types/* object */.Ry({
    srcSet: types/* record */.IM(Url/* UrlValidation.shape.value */.w.shape.value),
    alt: types/* string */.Z_()
});
var BlockImageSchema = types/* object */.Ry({
    srcSet: types/* array */.IX(Url/* UrlValidation.shape.value */.w.shape.value),
    alt: I18nText/* I18nTextValidation.shape.value */.B.shape.value
});
var HeroImageSchema = types/* object */.Ry({
    srcSet: types/* record */.IM(Url/* UrlValidation.shape.value */.w.shape.value),
    alt: I18nText/* I18nTextValidation.shape.value */.B.shape.value
});
// Announcement Banner Content Schema
var AnnouncementBannerContentSchema = types/* object */.Ry({
    title: types/* array */.IX(I18nText/* I18nTextValidation.shape.value */.B.shape.value),
    bgColor: Color/* ColorValidation.shape.value.nullable */.y.shape.value.nullable(),
    titleColor: Color/* ColorValidation.shape.value.nullable */.y.shape.value.nullable()
});
// Billboard Banner Content Schema
var BillboardBannerContentSchema = types/* object */.Ry({
    title: types/* array */.IX(I18nText/* I18nTextValidation.shape.value */.B.shape.value),
    description: I18nText/* I18nTextValidation.shape.value */.B.shape.value,
    url: Url/* UrlValidation.shape.value.nullable */.w.shape.value.nullable(),
    ctaText: I18nText/* I18nTextValidation.shape.value.nullable */.B.shape.value.nullable(),
    bgColor: Color/* ColorValidation.shape.value.nullable */.y.shape.value.nullable(),
    titleColor: Color/* ColorValidation.shape.value.nullable */.y.shape.value.nullable(),
    descriptionColor: Color/* ColorValidation.shape.value.nullable */.y.shape.value.nullable(),
    image: BillboardImageSchema.nullable()
});
// Block Banner Content Schema
var BlockBannerContentSchema = types/* object */.Ry({
    title: types/* array */.IX(I18nText/* I18nTextValidation.shape.value */.B.shape.value),
    description: I18nText/* I18nTextValidation.shape.value */.B.shape.value,
    ctaText: I18nText/* I18nTextValidation.shape.value */.B.shape.value,
    url: Url/* UrlValidation.shape.value */.w.shape.value,
    image: BlockImageSchema
});
// Hero Banner Content Schema
var HeroBannerContentSchema = types/* object */.Ry({
    title: types/* array */.IX(I18nText/* I18nTextValidation.shape.value */.B.shape.value),
    image: HeroImageSchema
});
// Banner Schemas with market support
var AnnouncementBannerSchema = types/* object */.Ry({
    type: types/* literal */.i0("announcement-banner"),
    viewport: types/* enum */.Km(Device/* ALLOWED_DEVICES */.Mz).optional(),
    content: AnnouncementBannerContentSchema
});
var BillboardBannerSchema = types/* object */.Ry({
    type: types/* literal */.i0("billboard-banner"),
    subtype: types/* enum */.Km(BannerSubtype/* ALLOWED_BANNER_SUB_TYPE */.pb),
    viewport: types/* enum */.Km(Device/* ALLOWED_DEVICES */.Mz).optional(),
    content: BillboardBannerContentSchema
});
var BlockBannerSchema = types/* object */.Ry({
    type: types/* literal */.i0("block-banner"),
    viewport: types/* enum */.Km(Device/* ALLOWED_DEVICES */.Mz).optional(),
    content: BlockBannerContentSchema
});
var HeroBannerSchema = types/* object */.Ry({
    type: types/* literal */.i0("hero-banner"),
    viewport: types/* enum */.Km(Device/* ALLOWED_DEVICES */.Mz).optional(),
    content: HeroBannerContentSchema
});
// Union of all banner types
var BannerSchema = types/* discriminatedUnion */.VK("type", [
    AnnouncementBannerSchema,
    BillboardBannerSchema,
    BlockBannerSchema,
    HeroBannerSchema, 
]);
var banners_GETBannerInformationResponse = types/* object */.Ry({
    banners: types/* array */.IX(BannerSchema)
});
var GETBannerInformationResponseSafe = types/* array */.IX(types/* object */.Ry({
    type: types/* enum */.Km(BannerType/* ALLOWED_BANNER_TYPE */.dM),
    subtype: types/* enum */.Km(BannerSubtype/* ALLOWED_BANNER_SUB_TYPE */.pb).optional(),
    viewport: types/* enum */.Km(Device/* ALLOWED_DEVICES */.Mz).optional(),
    content: types/* record */.IM(types/* string */.Z_(), types/* any */.Yj())
}));
var GETBannerInformationQuery = types/* object */.Ry({
    market: types/* string */.Z_(),
    language: types/* string */.Z_()
});

// EXTERNAL MODULE: ../../node_modules/zod/v3/errors.js
var errors = __webpack_require__(46904);
// EXTERNAL MODULE: ../../node_modules/zod/v3/helpers/parseUtil.js
var parseUtil = __webpack_require__(14834);
// EXTERNAL MODULE: ../../node_modules/zod/v3/helpers/util.js
var util = __webpack_require__(49342);
// EXTERNAL MODULE: ../../node_modules/zod/v3/ZodError.js
var ZodError = __webpack_require__(82799);
;// CONCATENATED MODULE: ../../node_modules/zod/v3/external.js







;// CONCATENATED MODULE: ../../node_modules/zod/index.js



/* harmony default export */ var zod = (external_namespaceObject);

// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/Title.ts
var Title = __webpack_require__(61659);
;// CONCATENATED MODULE: ../../packages/stayforlong/src/marketing/infrastructure/HTTPMarketingRepository/schemas/promotions/active/index.ts






var GETCurrentPromoMarketingQuery = zod.object({
    language: Language/* LanguageValidation.shape.value */._.shape.value,
    market: Market/* MarketValidation.shape.value */.iT.shape.value
});
var GETCurrentPromoMarketingResponse = zod.array(zod.object({
    global: zod.object({
        tags: zod.object({
            color: Color/* ColorValidation.shape.value */.y.shape.value,
            background: Color/* ColorValidation.shape.value */.y.shape.value,
            text: Title/* TitleValidation.shape.value */.p.shape.value
        })
    }),
    slug: Slug/* SlugValidation.shape.value */.g.shape.value
})).nullable();

;// CONCATENATED MODULE: ../../packages/stayforlong/src/marketing/infrastructure/HTTPMarketingRepository/index.ts














var HTTPMarketingRepository = /*#__PURE__*/ function() {
    "use strict";
    function HTTPMarketingRepository(config) {
        (0,_class_call_check/* default */.Z)(this, HTTPMarketingRepository);
        this.config = config;
    }
    var _proto = HTTPMarketingRepository.prototype;
    _proto.getActivePromotions = function getActivePromotions(param) {
        var market = param.market, language = param.language;
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var fetcher, API_GATEWAY, ref, err, json;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            FactoryFetcher/* FactoryFetcher.create */.$.create({
                                config: _this.config
                            }).fetcher()
                        ];
                    case 1:
                        fetcher = _state.sent();
                        API_GATEWAY = _this.config.get("API_GATEWAY");
                        return [
                            4,
                            fetcher.get("".concat(API_GATEWAY, "/promotions/active?market=").concat(market.value, "&language=").concat(language.value), {
                                schemas: {
                                    response: GETCurrentPromoMarketingResponse,
                                    query: GETCurrentPromoMarketingQuery
                                }
                            })
                        ];
                    case 2:
                        ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            2
                        ]), err = ref[0], json = ref[1];
                        if (err) throw DomainError/* DomainError.withCodes */.Z.withCodes(ErrorsCode/* ErrorsCode.LIST_PROMOTIONS_NOT_FOUND */.v.LIST_PROMOTIONS_NOT_FOUND).withCauses(err);
                        return [
                            2,
                            ListOfPromotion.fromAPI({
                                json: json,
                                market: market,
                                language: language
                            })
                        ];
                }
            });
        })();
    };
    _proto.getTopDestination = function getTopDestination(param) {
        var bannerId = param.bannerId, market = param.market, lang = param.lang;
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var fetcher, API_GATEWAY, ref, err, json;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            FactoryFetcher/* FactoryFetcher.create */.$.create({
                                config: _this.config
                            }).fetcher()
                        ];
                    case 1:
                        fetcher = _state.sent();
                        API_GATEWAY = _this.config.get("API_GATEWAY");
                        return [
                            4,
                            fetcher.get("".concat(API_GATEWAY, "/v1/banners/").concat(bannerId.value, "/destinations?market=").concat(market.value, "&lang=").concat(lang.value), {
                                schemas: {
                                    response: GETTopDestinationsByBannerIdResponse,
                                    query: GETTopDestinationsByBannerIdQuery
                                }
                            })
                        ];
                    case 2:
                        ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            2
                        ]), err = ref[0], json = ref[1];
                        if (err) throw DomainError/* DomainError.withCodes */.Z.withCodes(ErrorsCode/* ErrorsCode.LIST_TOP_DESTINATIONS_NOT_FOUND */.v.LIST_TOP_DESTINATIONS_NOT_FOUND);
                        return [
                            2,
                            ListOfTopDestination/* ListOfTopDestination.fromAPI */.t.fromAPI({
                                json: json
                            })
                        ];
                }
            });
        })();
    };
    _proto.getBanners = function getBanners(param) {
        var market = param.market, lang = param.lang, bannerServiceFeatureFlag = param.bannerServiceFeatureFlag, operatingSystem = param.operatingSystem, platform = param.platform;
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (bannerServiceFeatureFlag.isEnabled()) {
                    return [
                        2,
                        _this.getCurrentBanners({
                            market: market,
                            lang: lang,
                            operatingSystem: operatingSystem,
                            platform: platform
                        })
                    ];
                }
                return [
                    2,
                    _this.getLegacyBanners({
                        market: market,
                        lang: lang
                    })
                ];
            });
        })();
    };
    _proto.getLegacyBanners = function getLegacyBanners(param) {
        var market = param.market, lang = param.lang;
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var fetcher, staticsHost, bannersFileName, ref, err, json;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            FactoryFetcher/* FactoryFetcher.create */.$.create({
                                config: _this.config
                            }).fetcher()
                        ];
                    case 1:
                        fetcher = _state.sent();
                        staticsHost = _this.config.get("STATICS_HOST");
                        bannersFileName = _this.config.get("BANNERS_FILE_NAME");
                        return [
                            4,
                            fetcher.get("".concat(staticsHost, "/banners/").concat(bannersFileName), {
                                schemas: {
                                    response: GETBannerInformationResponseLenient
                                }
                            })
                        ];
                    case 2:
                        ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            2
                        ]), err = ref[0], json = ref[1];
                        if (err) {
                            return [
                                2,
                                ListOfBanner/* ListOfBanner.empty */.m.empty()
                            ];
                        }
                        return [
                            2,
                            ListOfBanner/* ListOfBanner.fromLegacyApi */.m.fromLegacyApi({
                                list: json.banners,
                                market: market,
                                language: lang
                            })
                        ];
                }
            });
        })();
    };
    _proto.getCurrentBanners = function getCurrentBanners(param) {
        var market = param.market, lang = param.lang, operatingSystem = param.operatingSystem, platform = param.platform;
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var fetcher, apiGateway, ref, err, json;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            FactoryFetcher/* FactoryFetcher.create */.$.create({
                                config: _this.config
                            }).fetcher()
                        ];
                    case 1:
                        fetcher = _state.sent();
                        apiGateway = _this.config.get("API_GATEWAY");
                        return [
                            4,
                            fetcher.get("".concat(apiGateway, "/banners?market=").concat(market.value, "&language=").concat(lang.value, "&os=").concat(operatingSystem.value, "&platform=").concat(platform.value), {
                                schemas: {
                                    response: GETBannerInformationResponseSafe,
                                    query: GETBannerInformationQuery
                                }
                            })
                        ];
                    case 2:
                        ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            2
                        ]), err = ref[0], json = ref[1];
                        if (err) {
                            return [
                                2,
                                ListOfBanner/* ListOfBanner.empty */.m.empty()
                            ];
                        }
                        return [
                            2,
                            ListOfBanner/* ListOfBanner.fromCurrentApi */.m.fromCurrentApi({
                                list: json,
                                market: market,
                                language: lang
                            })
                        ];
                }
            });
        })();
    };
    HTTPMarketingRepository.create = function create(param) {
        var config = param.config;
        return new HTTPMarketingRepository(config);
    };
    return HTTPMarketingRepository;
}();


/***/ }),

/***/ 85141:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ GetCurrentLanguageSharedUseCase; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50853);
/* harmony import */ var _infrastructure_SharedRepositoryProxy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76472);




var GetCurrentLanguageSharedUseCase = /*#__PURE__*/ function() {
    "use strict";
    function GetCurrentLanguageSharedUseCase(repository) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, GetCurrentLanguageSharedUseCase);
        this.repository = repository;
    }
    var _proto = GetCurrentLanguageSharedUseCase.prototype;
    _proto.execute = function execute() {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                return [
                    2,
                    _this.repository.language()
                ];
            });
        })();
    };
    GetCurrentLanguageSharedUseCase.create = function create(param) {
        var config = param.config, repository = param.repository;
        return new GetCurrentLanguageSharedUseCase(repository !== null && repository !== void 0 ? repository : _infrastructure_SharedRepositoryProxy__WEBPACK_IMPORTED_MODULE_0__/* .SharedRepositoryProxy.create */ .B.create({
            config: config
        }));
    };
    return GetCurrentLanguageSharedUseCase;
}();
GetCurrentLanguageSharedUseCase.USE_CASE_NAME = "GetCurrentLanguageSharedUseCase";



/***/ }),

/***/ 34099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ GetCurrentMarketSharedUseCase; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50853);
/* harmony import */ var _infrastructure_SharedRepositoryProxy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76472);




var GetCurrentMarketSharedUseCase = /*#__PURE__*/ function() {
    "use strict";
    function GetCurrentMarketSharedUseCase(repository) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, GetCurrentMarketSharedUseCase);
        this.repository = repository;
    }
    var _proto = GetCurrentMarketSharedUseCase.prototype;
    _proto.execute = function execute() {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                return [
                    2,
                    _this.repository.market()
                ];
            });
        })();
    };
    GetCurrentMarketSharedUseCase.create = function create(param) {
        var config = param.config, repository = param.repository;
        return new GetCurrentMarketSharedUseCase(repository !== null && repository !== void 0 ? repository : _infrastructure_SharedRepositoryProxy__WEBPACK_IMPORTED_MODULE_0__/* .SharedRepositoryProxy.create */ .B.create({
            config: config
        }));
    };
    return GetCurrentMarketSharedUseCase;
}();
GetCurrentMarketSharedUseCase.USE_CASE_NAME = "GetCurrentMarketSharedUseCase";



/***/ })

}]);